import { publicClient, privateClient } from "../../configs/axiosConfig";
import userEndpoints from "./userEndpoints";

// API liên quan đến người dùng
const userApi = {
  // API đăng nhập
  signin: async ({ username, password }) => {
    try {
      const response = await publicClient.post(userEndpoints.signin, {
        username,
        password,
      });
      return { response }; // ✅ Always return an object with response
    } catch (err) {
      return { err }; // ✅ Catch and return the error too
    }
  },

  // API đăng ký
  signup: async ({
    username,
    password,
    confirmPassword,
    displayName,
    photo,
  }) => {
    try {
      const response = await publicClient.post(userEndpoints.signup, {
        username,
        password,
        confirmPassword,
        displayName,
        photo,
      });
      return { response };
    } catch (err) {
      return { err }; // ✅ Catch and return the error too
    }
  },

  // API lấy thông tin người dùng (yêu cầu xác thực)
  getUserInfo: async () => {
    try {
      const response = await privateClient.get(userEndpoints.getInfo);
      return response.data;
    } catch (err) {
      throw new Error(
        err.response?.data?.message || "Failed to fetch user info"
      );
    }
  },

  // API cập nhật mật khẩu (yêu cầu xác thực)
  updatePassword: async ({ password, newPassword, confirmNewPassword }) => {
    try {
      const response = await privateClient.put(userEndpoints.updatePassword, {
        password,
        newPassword,
        confirmNewPassword,
      });
      return response.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Password update failed");
    }
  },

  updateProfile: async (data) => {
    try {
      const response = await privateClient.put(
        userEndpoints.updateProfile,
        data
      );
      return response;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Profile update failed");
    }
  },

  getListCardDesign: async (userId) => {
    try {
      const response = await privateClient.post(
        userEndpoints.getListCardDesign,
        { userFrom: userId }
      );
      return response.data;
    } catch (err) {
      throw new Error(
        err.response?.data?.message || "Failed to fetch card design list"
      );
    }
  },

  verifyEmail: async (otp, username) => {
    try {
      const response = await publicClient.post(
        userEndpoints.verifyEmail, // example: "/api/v1/auth/verify-email"
        { username, otp } // send username and otp
      );
      return response.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Failed to verify email");
    }
  },

  resendOtp: async (username) => {
    try {
      const response = await publicClient.post(
        userEndpoints.resendOtp, // example: "/api/v1/auth/resend-otp"
        { username }
      );
      return response.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Failed to resend OTP");
    }
  },

  forgotPassword: async (email) => {
    try {
      const response = await publicClient.post(userEndpoints.forgotPassword, {
        email,
      });
      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },

  resetPassword: async (token, password) => {
    try {
      const response = await publicClient.post(
        `/v1/user/reset-password/${token}`,
        {
          password,
        }
      );
      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },
};

export default userApi;
